// Botao flutuante que a pessoa arrasta para onde quiser. A posicao fica
// guardada no navegador (distancia da direita e de baixo, assim o painel que
// abre acima do botao continua ancorado nele). Um arraste nao conta como clique.
import { ref, computed } from 'vue';
import { useEventListener } from '@vueuse/core';

const DRAG_THRESHOLD_PX = 4;
const EDGE_PX = 8;
const BUTTON_PX = 56;

const readSaved = key => {
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null');
    return Number.isFinite(saved?.right) && Number.isFinite(saved?.bottom)
      ? saved
      : null;
  } catch {
    return null;
  }
};

export function useDraggableFloat(storageKey, defaults) {
  const clamp = ({ right, bottom }) => ({
    right: Math.min(
      Math.max(right, EDGE_PX),
      window.innerWidth - BUTTON_PX - EDGE_PX
    ),
    bottom: Math.min(
      Math.max(bottom, EDGE_PX),
      window.innerHeight - BUTTON_PX - EDGE_PX
    ),
  });

  const position = ref(clamp(readSaved(storageKey) || defaults()));
  let start = null;
  let dragged = false;
  let suppressNextClick = false;

  const onPointerDown = event => {
    start = {
      x: event.clientX,
      y: event.clientY,
      ...position.value,
    };
    dragged = false;
  };

  const onPointerMove = event => {
    if (!start) return;
    const dx = event.clientX - start.x;
    const dy = event.clientY - start.y;
    if (!dragged && Math.hypot(dx, dy) < DRAG_THRESHOLD_PX) return;
    dragged = true;
    position.value = clamp({
      right: start.right - dx,
      bottom: start.bottom - dy,
    });
  };

  const onPointerUp = () => {
    if (!start) return;
    start = null;
    if (!dragged) return;
    suppressNextClick = true;
    try {
      localStorage.setItem(storageKey, JSON.stringify(position.value));
    } catch {
      // armazenamento bloqueado: a posicao vale so ate recarregar
    }
  };

  // true quando o clique veio do fim de um arraste e deve ser ignorado
  const consumeDragClick = () => {
    const wasDrag = suppressNextClick;
    suppressNextClick = false;
    return wasDrag;
  };

  useEventListener(window, 'pointermove', onPointerMove);
  useEventListener(window, 'pointerup', onPointerUp);
  useEventListener(window, 'resize', () => {
    position.value = clamp(position.value);
  });

  const style = computed(() => ({
    right: `${position.value.right}px`,
    bottom: `${position.value.bottom}px`,
  }));

  return { position, style, onPointerDown, consumeDragClick };
}
